/* claude one page - storefront behaviour.
   Money is NEVER formatted here: the cart drawer is re-rendered by Shopify's
   Section Rendering API so every price comes from Liquid's `money` filter. */
(function(){
'use strict';
var $=function(s,c){return (c||document).querySelector(s)};
var $$=function(s,c){return [].slice.call((c||document).querySelectorAll(s))};
var ROOT=(window.COP&&window.COP.rootUrl)||'/';

/* reveal */
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.06});
$$('.rv').forEach(function(el){io.observe(el)});

/* mobile menu */
document.addEventListener('click',function(e){
  var b=e.target.closest('#burger');
  if(b){var m=$('#mmenu');if(m){var o=m.classList.toggle('open');b.setAttribute('aria-expanded',o)}return}
  if(e.target.closest('#mmenu a')){var m2=$('#mmenu');if(m2)m2.classList.remove('open')}
});

/* ---------- offer selection, synced across every box ----------
   Keyed on data-tier, NOT data-variant: all three tiers are the same SKU at
   quantity 1 / 2 / 3, so the variant id is identical across them and cannot
   identify a selection. Every box and the sticky bar stay in lockstep. */
var selected=null;
function syncSelection(el){
  if(!el) return;
  selected={
    tier:el.dataset.tier, variant:el.dataset.variant, qty:el.dataset.qty||'1',
    price:el.dataset.price, compare:el.dataset.compare||'',
    title:el.dataset.title||'', sub:el.dataset.sub||''
  };
  $$('[data-tier]').forEach(function(x){
    var on = x.dataset.tier===selected.tier;
    x.classList.toggle('on', on);
    if(x.hasAttribute('aria-checked')) x.setAttribute('aria-checked', on?'true':'false');
  });
  $$('[data-buy-label]').forEach(function(x){
    var t=x.dataset.buyLabel||'Get Orbit';
    x.textContent = x.dataset.short==='1' ? t+' →' : t+' – '+selected.price+' →';
  });
  var sp=$('#stPrice'); if(sp) sp.innerHTML=selected.price+(selected.compare?'<s>'+selected.compare+'</s>':'');
  var sn=$('#stName');  if(sn&&selected.title) sn.textContent=selected.title;
  var ss=$('#stSub');   if(ss&&selected.sub)   ss.textContent=selected.sub;
}
document.addEventListener('click',function(e){
  var sel=e.target.closest('[data-tier]');
  if(sel && !e.target.closest('[data-add]')) syncSelection(sel);
});
document.addEventListener('keydown',function(e){
  if(e.key!=='Enter' && e.key!==' ') return;
  var sel=e.target.closest && e.target.closest('[data-tier][role="radio"]');
  if(sel){ e.preventDefault(); syncSelection(sel); }
});

/* ---------- five heads ---------- */
document.addEventListener('click',function(e){
  var b=e.target.closest('.hbtn'); if(!b) return;
  var wrap=b.closest('.heads');
  $$('.hbtn',wrap).forEach(function(x){x.classList.remove('on');x.setAttribute('aria-selected','false')});
  b.classList.add('on'); b.setAttribute('aria-selected','true');
  var img=$('.hpanel img',wrap), nm=$('.hpanel .lbl b',wrap), ds=$('.hpanel .lbl span',wrap);
  if(img){img.style.opacity=0;setTimeout(function(){img.src=b.dataset.img;img.style.opacity=1},150)}
  if(nm) nm.textContent=b.dataset.name;
  if(ds) ds.textContent=b.dataset.desc;
});

/* ---------- faq ---------- */
document.addEventListener('click',function(e){
  var b=e.target.closest('.q > button'); if(!b) return;
  var q=b.parentElement,o=q.classList.toggle('open'); b.setAttribute('aria-expanded',o);
});

/* ---------- before / after ---------- */
$$('.ba').forEach(function(ba){
  var range=$('.ba-range',ba),handle=$('.ba-handle',ba),after=$('[data-after]',ba);
  if(!range||!handle||!after) return;
  function set(v){v=Math.max(0,Math.min(100,v));handle.style.left=v+'%';after.style.clipPath='inset(0 0 0 '+v+'%)';range.value=v}
  range.addEventListener('input',function(){set(+range.value)});
  var dragging=false;
  function drag(e){var r=ba.getBoundingClientRect();var x=(e.touches?e.touches[0].clientX:e.clientX)-r.left;set(x/r.width*100)}
  ba.addEventListener('mousedown',function(e){dragging=true;drag(e)});
  addEventListener('mousemove',function(e){if(dragging)drag(e)});
  addEventListener('mouseup',function(){dragging=false});
  ba.addEventListener('touchstart',drag,{passive:true});
  ba.addEventListener('touchmove',drag,{passive:true});
  set(50);
});

/* ---------- sticky bar ---------- */
(function(){
  var sticky=$('#sticky'), anchor=$('#pbox1');
  if(!sticky||!anchor) return;
  new IntersectionObserver(function(es){
    es.forEach(function(e){sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top<0)});
  },{threshold:0}).observe(anchor);
})();

/* ---------- cart ---------- */
function drawer(){return $('#drawer')}
function openCart(){var d=drawer(),s=$('#scrim');if(!d)return;d.classList.add('on');if(s)s.classList.add('on');d.setAttribute('aria-hidden','false')}
function closeCart(){var d=drawer(),s=$('#scrim');if(!d)return;d.classList.remove('on');if(s)s.classList.remove('on');d.setAttribute('aria-hidden','true')}

async function refreshCart(){
  try{
    var res=await fetch(ROOT+'?sections=cop-cart-drawer');
    var data=await res.json();
    var html=data['cop-cart-drawer'];
    if(!html) return;
    var doc=new DOMParser().parseFromString(html,'text/html');
    var nb=doc.getElementById('drBody'), ob=$('#drBody');
    if(nb&&ob) ob.innerHTML=nb.innerHTML;
    var nt=doc.getElementById('drTotal'), ot=$('#drTotal');
    if(nt&&ot) ot.textContent=nt.textContent;
    var nc=doc.getElementById('drCount'), badge=$('#cartN');
    if(nc&&badge) badge.textContent=nc.textContent.trim();
    var ncb=doc.getElementById('drCheckout'), ocb=$('#drCheckout');
    if(ncb&&ocb) ocb.disabled=ncb.disabled;
  }catch(err){}
}

async function addItems(items){
  try{
    var res=await fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});
    if(!res.ok) throw new Error('atc');
    await refreshCart(); openCart();
  }catch(err){ window.location.href=ROOT+'cart'; }
}

document.addEventListener('click',function(e){
  if(e.target.closest('#cartBtn')){e.preventDefault();openCart();return}
  if(e.target.closest('#drClose')||e.target.closest('#scrim')){closeCart();return}

  var rm=e.target.closest('.dr-rm');
  if(rm){e.preventDefault();
    fetch(ROOT+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:rm.dataset.key,quantity:0})}).then(refreshCart);
    return}

  var add=e.target.closest('[data-add]');
  if(add){
    e.preventDefault();
    /* A card's own button carries its tier explicitly. The sticky bar and the
       big closing button carry nothing, so they follow the current selection. */
    var id  = add.dataset.addVariant || (selected && selected.variant);
    var qty = add.dataset.addQty     || (selected && selected.qty) || 1;
    if(!id) return;
    addItems([{id:Number(id), quantity:Number(qty)}]);
  }
});
addEventListener('keydown',function(e){if(e.key==='Escape')closeCart()});

/* initial selection: whichever tier is marked on, else the first */
syncSelection($('[data-tier].on')||$('[data-tier]'));
})();
